<template>
  <table class="table">
    <thead>
      <tr>
        <th-orderable
          v-for="column in columns"
          :key="column.key"
          :column="column"
          @click="column.orderable !== false ? onColumnClick(column) : null"
        />

        <th></th>
      </tr>
    </thead>
    <tbody>
      <UserItem
        @update-item-activity="onUpdateItemActivity"
        @delete="onDeleteItem"
        v-for="model in models"
        :model="model"
        v-bind:key="model.id"
      />
    </tbody>
  </table>
</template>

<script>
import columns from "../misc/user-columns";
import UserItem from "./UserItem";
import modelListMixin from "@/components/crud/mixins/model-list.mixin";
import ThOrderable from "@/components/common/table/ThOrderable";

export default {
  name: "user-list",
  mixins: [modelListMixin],
  components: {
    UserItem,
    ThOrderable
  },
  data() {
    return {
      columns: columns
    };
  },
  mounted() {
    jQuery(document).ready(() => {
      this.initJQuery();
    });
  },
  methods: {
    onColumnClick(column) {
      this.$emit("columnClick", column);
    },
    initJQuery() {
      // Multiselect options
      $(".filter-table select").multiselect({
        buttonText: function(options, select) {
          return "Filter";
        },
        buttonTitle: function(options, select) {
          var labels = [];
          options.each(function() {
            labels.push($(this).text());
          });
          return labels.join(" - ");
        }
      });

      $(".filter-table-search select").multiselect({
        enableFiltering: true,
        filterPlaceholder: "Zoeken...",
        buttonText: function(options, select) {
          return "Filter";
        },
        buttonTitle: function(options, select) {
          var labels = [];
          options.each(function() {
            labels.push($(this).text());
          });
          return labels.join(" - ");
        }
      });
    }
  }
};
</script>
